module.exports = __webpack_public_path__ + "static/img/David-Nofoaluma.54b640a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/David-Nofoaluma.jpg
// module id = +dG3
// module chunks = 0